import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getClosureBriefColumns } from "./lib/getClosureBriefColumns";
import { useClosuresBriefsList } from "./lib/hooks/useClosuresBriefsList";
import { useClosuresPricingPoc } from "./lib/hooks/useClosuresPricingPoc";
import { useClosuresUserIdParam } from "./lib/hooks/useClosuresUserIdParam";
import styles from "./styles.module.scss";
import { ClosuresBriefsSection } from "./ui/ClosuresBriefsSection";
import { ClosuresPageHeader } from "./ui/ClosuresPageHeader";

export function ClosuresManagementPage() {
  const { userIdParam, setUserIdParam, isSuperUser, isSuccess } =
    useClosuresUserIdParam();

  const {
    pricingWorkloadData,
    isPricingWorkloadLoading,
    selectedPoc,
    isPricingWorkloadPerUserLoading,
    getTabCount,
    pocSelectOptions,
    pocSelectValue,
  } = useClosuresPricingPoc({ userIdParam, isSuperUser });

  const {
    closureStatus,
    setClosureStatus,
    pageNo,
    pageSize,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    briefs,
    isFetching,
    totaldata,
    handlePaginationChange,
  } = useClosuresBriefsList({
    userIdParam,
    selectedPocUserId: selectedPoc?.userId,
    isQueryEnabled: isSuccess,
  });
  const navigate = useNavigate();

  const columns = useMemo(
    () => getClosureBriefColumns(userIdParam, navigate),
    [userIdParam]
  );

  return (
    <div className={styles.closuresPage}>
      <ClosuresPageHeader
        isSuperUser={isSuperUser}
        pricingWorkloadData={pricingWorkloadData}
        isPricingWorkloadLoading={isPricingWorkloadLoading}
        pocSelectOptions={pocSelectOptions}
        pocSelectValue={pocSelectValue}
        onPocChange={setUserIdParam}
        selectedPoc={selectedPoc}
      />

      <ClosuresBriefsSection
        isLoading={isPricingWorkloadPerUserLoading}
        closureStatus={closureStatus}
        onClosureStatusChange={setClosureStatus}
        getTabCount={getTabCount}
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        columns={columns}
        briefs={briefs}
        isFetching={isFetching}
        pageNo={pageNo}
        pageSize={pageSize}
        totaldata={totaldata}
        onPaginationChange={handlePaginationChange}
        debouncedSearchQuery={debouncedSearchQuery}
      />
    </div>
  );
}
